"use strict";
/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.Areas = void 0;
const areasGetAgentListingsInAreaAreasAgentListingsGet_js_1 = require("../funcs/areasGetAgentListingsInAreaAreasAgentListingsGet.js");
const areasGetCrimesInAreaAreasCrimeGet_js_1 = require("../funcs/areasGetCrimesInAreaAreasCrimeGet.js");
const areasGetHousePriceIndexInAreaAreasHousePriceIndexGet_js_1 = require("../funcs/areasGetHousePriceIndexInAreaAreasHousePriceIndexGet.js");
const areasGetOutcodesInAreaAreasOutcodesGet_js_1 = require("../funcs/areasGetOutcodesInAreaAreasOutcodesGet.js");
const areasGetPolygonsInAreaAreasPolygonsGet_js_1 = require("../funcs/areasGetPolygonsInAreaAreasPolygonsGet.js");
const areasGetPostcodesInAreaAreasPostcodesGet_js_1 = require("../funcs/areasGetPostcodesInAreaAreasPostcodesGet.js");
const areasGetPropertiesInAreaAreasPropertiesGet_js_1 = require("../funcs/areasGetPropertiesInAreaAreasPropertiesGet.js");
const areasGetPropertyListingsInAreaAreasPropertyListingsGet_js_1 = require("../funcs/areasGetPropertyListingsInAreaAreasPropertyListingsGet.js");
const areasGetPropertyTransactionsInAreaAreasPropertyTransactionsGet_js_1 = require("../funcs/areasGetPropertyTransactionsInAreaAreasPropertyTransactionsGet.js");
const sdks_js_1 = require("../lib/sdks.js");
const fp_js_1 = require("./types/fp.js");
class Areas extends sdks_js_1.ClientSDK {
    /**
     * Get Agent Listings In Area
     *
     * @remarks
     * Get agents listings for an area.
     *
     * ## Valid query parameters
     *
     * <details>
     * <summary>Click to view information on valid query parameters for this endpoint</summary>
     *
     * The following combinations of query parameters are valid, invalid combinations will result in a `400 Bad Request`
     * with details why they are not valid.
     *
     * | Combination                       | Description                                                                                                                                                 |
     * | :-------------------------------- | :---------------------------------------------------------------------------------------------------------------------------------------------------------- |
     * | Postcode only                     | Will return only the agents that have listed in the postcode.                                                                                                            |
     * | Outcode only                      | Will return only the agents that have listed in the outcode.                                                                                                             |
     * | Sector only                       | Will return only the agents that have listed in the sector.
     * | Single point parameter and radius | Will return all agents that have listed within the radius of the lat/lon given.                                                                                          |
     * | Multiple point parameters         | Will return all agents that have listed enclosed within a polygon defined by the given point parameters. At least 3 point parameters must be passed to define a polygon. |
     *
     * </details>
     */
    async getAgentListingsInAreaAreasAgentListingsGet(security, request, options) {
        return (0, fp_js_1.unwrapAsync)((0, areasGetAgentListingsInAreaAreasAgentListingsGet_js_1.areasGetAgentListingsInAreaAreasAgentListingsGet)(this, security, request, options));
    }
    /**
     * Get Crimes In Area
     *
     * @remarks
     * Get details of crimes in area.
     *
     * - This endpoint can be used to get details of crimes in a specific area.
     * - The data is sourced from <https://data.police.uk/>
     *
     *  ## Pagination
     *
     * <details>
     * <summary>Click to view information on using pagination for this endpoint</summary>
     *
     *  > This endpoint is paginated. [View the accompanying documentation](https://docs.data.api.street.co.uk/doc/user-guide-pOEzjc8scS#h-pagination) for more information on using pagination.
     * </details>
     *
     * ## Valid query parameters
     *
     * <details>
     * <summary>Click to view information on valid query parameters for this endpoint</summary>
     *
     * The following combinations of query parameters are valid, invalid combinations will result in a `400 Bad Request` with details why they are not valid.
     *
     * | Combination                                                                | Description                                                                                                                                                                                                                                                                                                                                                                                                                                                                                            |
     * | :------------------------------------------------------------------------- | :----------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------- |
     * | Postcode only                                                              | Will return only the crime 200 meter around the postcode.                                                                                                                                                                                                                                                                                                                                                                                                                                                       |
     * | Outcode only                                                               | Will return only the crime in the outcode.                                                                                                                                                                                                                                                                                                                                                                                                                                                        |
     * | Sector only                                                                | Will return only the crime in the Spectre Sector (e.g `M28 1`). This parameter can be passed multiple times or a single time as a `\|` delimited string to get multiple sectors.                                                                                                                                                                                                                                                                                                                  |
     * | Single point parameter and radius                                          | Will return all crime within the radius of the lat/lon given.                                                                                                                                                                                                                                                                                                                                                 |
     * | Multiple point parameters                                                  | Will return all crime enclosed within a polygon defined by the given point parameters. At least 3 point parameters must be passed to define a polygon.                                                                                                                                                                                                                                       |
     * </details>
     *
     * ### Filtering
     *
     * <details>
     * <summary>Click to view information on filtering results</summary>
     *
     * Other `filter[]` query parameters can be included in any combination to allow for filtering of the result set.
     *
     * You can use the parameter `filter[crime_type]` which takes multiple values to filter crime by types.
     * You can use the parameter `filter[start_date]` or `filter[end_date]` to filter the time range when the crime occurred.
     * </details>
     */
    async getCrimesInAreaAreasCrimeGet(security, request, options) {
        return (0, fp_js_1.unwrapAsync)((0, areasGetCrimesInAreaAreasCrimeGet_js_1.areasGetCrimesInAreaAreasCrimeGet)(this, security, request, options));
    }
    /**
     * Get House Price Index In Area
     *
     * @remarks
     * Get Land Registry House Price Index data for a UK local authority.
     *
     * - The response includes all monthly house price index data published for the area unless a date parameter is passed.
     * - You can pass both a start date and an end date, or any combination of the two, in the from `YYYY-MM`. The start date must be less than or equal to the end date.
     * - Data is available from 1995 for England and Wales, 2004 for Scotland and 2005 for Northern Ireland.
     *
     * ## Valid query parameters
     *
     * <details>
     * <summary>Click to view information on valid query parameters for this endpoint</summary>
     *
     * The following combinations of query parameters are valid, invalid combinations will result in a `400 Bad Request`
     * with details why they are not valid.
     *
     * | Combination                           | Description                                            |
     * | :------------------------------------ | :----------------------------------------------------- |
     * | Postcode only                         | Will return only the HPI data in the postcode.         |
     * | ONS Local Authority (LAD20) Code only | Will return only the HPI data for the given authority. |
     *
     * </details>
     *
     * ### Filtering
     *
     * <details>
     * <summary>Click to view information on filtering results</summary>
     *
     * Other `filter[]` query parameters can be included in any combination to allow for filtering of the result set.
     *
     * </details>
     */
    async getHousePriceIndexInAreaAreasHousePriceIndexGet(security, filterEndMonth, filterStartMonth, localAuthorityDistrictCode, postcode, options) {
        return (0, fp_js_1.unwrapAsync)((0, areasGetHousePriceIndexInAreaAreasHousePriceIndexGet_js_1.areasGetHousePriceIndexInAreaAreasHousePriceIndexGet)(this, security, filterEndMonth, filterStartMonth, localAuthorityDistrictCode, postcode, options));
    }
    /**
     * Get Outcodes In Area
     *
     * @remarks
     * Get outcodes within an area.
     *
     * ## Valid query parameters
     *
     * <details>
     * <summary>Click to view information on valid query parameters for this endpoint</summary>
     *
     * The following combinations of query parameters are valid, invalid combinations will result in a `400 Bad Request`
     * with details why they are not valid.
     * | Combination                       | Description                                                                                                                                                 |
     * | :-------------------------------- | :---------------------------------------------------------------------------------------------------------------------------------------------------------- |
     * | Single point parameter and radius | Will return all outcodes within the radius of the lat/lon given.                                                                                          |
     * | Multiple point parameters         | Will return all outcodes enclosed within a polygon defined by the given point parameters. At least 3 point parameters must be passed to define a polygon. |
     *
     * </details>
     *
     * ## Multiple valued query parameters
     *
     * <details>
     * <summary>Click to view information on using query parameters that take multiple values</summary>
     *
     * > [View the accompanying documentation](https://docs.data.api.street.co.uk/doc/user-guide-pOEzjc8scS#h-using-multiple-query-parameters) for more information on using query parameters that take multiple values.
     *
     * </details>
     */
    async getOutcodesInAreaAreasOutcodesGet(security, point, radius, options) {
        return (0, fp_js_1.unwrapAsync)((0, areasGetOutcodesInAreaAreasOutcodesGet_js_1.areasGetOutcodesInAreaAreasOutcodesGet)(this, security, point, radius, options));
    }
    /**
     * Get Polygons In Area
     *
     * @remarks
     * Get polygons within an area.
     *
     * ## Valid query parameters
     *
     * <details>
     * <summary>Click to view information on valid query parameters for this endpoint</summary>
     *
     * The following combinations of query parameters are valid, invalid combinations will result in a `400 Bad Request` with details why they are not valid.
     *
     * | Combination                       | Description                                                                                                                                                 |
     * | :-------------------------------- | :---------------------------------------------------------------------------------------------------------------------------------------------------------- |
     * | Single point parameter and radius | Will return all polygons within the radius of the lat/lon given.                                                                                          |
     * | Multiple point parameters         | Will return all polygons enclosed within a polygon defined by the given point parameters. At least 3 point parameters must be passed to define a polygon. |
     *
     * </details>
     *
     * ## Pagination
     *
     * <details>
     * <summary>Click to view information on using pagination for this endpoint</summary>
     *
     *  > This endpoint is paginated. [View the accompanying documentation](https://docs.data.api.street.co.uk/doc/user-guide-pOEzjc8scS#h-pagination) for more information on using pagination.
     * </details>
     *
     * ## Multiple valued query parameters
     *
     * <details>
     * <summary>Click to view information on using query parameters that take multiple values</summary>
     *
     * > [View the accompanying documentation](https://docs.data.api.street.co.uk/doc/user-guide-pOEzjc8scS#h-using-multiple-query-parameters) for more information on using query parameters that take multiple values.
     *
     * </details>
     *
     * ## Sorting
     *
     * <details>
     * <summary>Click to view information on using sorting for this endpoint</summary>
     *
     * > [View the accompanying documentation](https://docs.data.api.street.co.uk/doc/user-guide-pOEzjc8scS#h-sorting) for more information on using sorting.
     *
     * </details>
     */
    async getPolygonsInAreaAreasPolygonsGet(security, request, options) {
        return (0, fp_js_1.unwrapAsync)((0, areasGetPolygonsInAreaAreasPolygonsGet_js_1.areasGetPolygonsInAreaAreasPolygonsGet)(this, security, request, options));
    }
    /**
     * Get Postcodes In Area
     *
     * @remarks
     * Get postcodes within an area.
     *
     * ## Valid query parameters
     *
     * <details>
     * <summary>Click to view information on valid query parameters for this endpoint</summary>
     *
     * The following combinations of query parameters are valid, invalid combinations will result in a `400 Bad Request` with details why they are not valid.
     * | Combination                       | Description                                                                                                                                                 |
     * | :-------------------------------- | :---------------------------------------------------------------------------------------------------------------------------------------------------------- |
     * | Single point parameter and radius | Will return all polygons within the radius of the lat/lon given.                                                                                          |
     * | Multiple point parameters         | Will return all polygons enclosed within a polygon defined by the given point parameters. At least 3 point parameters must be passed to define a polygon. |
     *
     * </details>
     *
     * ## Pagination
     *
     * <details>
     * <summary>Click to view information on using pagination for this endpoint</summary>
     *
     *  > This endpoint is paginated. [View the accompanying documentation](https://docs.data.api.street.co.uk/doc/user-guide-pOEzjc8scS#h-pagination) for more information on using pagination.
     * </details>
     *
     * ## Multiple valued query parameters
     *
     * <details>
     * <summary>Click to view information on using query parameters that take multiple values</summary>
     *
     * > [View the accompanying documentation](https://docs.data.api.street.co.uk/doc/user-guide-pOEzjc8scS#h-using-multiple-query-parameters) for more information on using query parameters that take multiple values.
     *
     * </details>
     */
    async getPostcodesInAreaAreasPostcodesGet(security, page, point, radius, results, options) {
        return (0, fp_js_1.unwrapAsync)((0, areasGetPostcodesInAreaAreasPostcodesGet_js_1.areasGetPostcodesInAreaAreasPostcodesGet)(this, security, page, point, radius, results, options));
    }
    /**
     * Get Properties In Area
     *
     * @remarks
     * Get properties within an area.
     *
     * - This endpoint functions similarly similar to `/properties/{street_group_property_id}` except it returns multiple properties
     * using an area.
     * - The properties returned have a [smaller subset of fields](#model/multipleproperty) to accomodate for the larger response size.
     *
     * ## Valid query parameters
     *
     * <details>
     * <summary>Click to view information on valid query parameters for this endpoint</summary>
     *
     * The following combinations of query parameters are valid, invalid combinations will result in a `400 Bad Request` with details why they are not valid.
     *
     * | Combination                                                                | Description                                                                                                                                                                                                                                                                                                                                                                                                                                                                                            |
     * | :------------------------------------------------------------------------- | :----------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------- |
     * | Postcode only                                                              | Will return only the properties in the postcode.                                                                                                                                                                                                                                                                                                                                                                                                                                                       |
     * | Outcode only                                                               | Will return only the properties in the outcode.                                                                                                                                                                                                                                                                                                                                                                                                                                                        |
     * | Sector only                                                                | Will return only the properties in the Spectre Sector (e.g `M28 1`). This parameter can be passed multiple times or a single time as a `\|` delimited string to get multiple sectors.                                                                                                                                                                                                                                                                                                                  |
     * | Single point parameter and radius                                          | Will return all properties within the radius of the lat/lon given. The parameter `filter[sectors]` can be used with this parameter to filter results.                                                                                                                                                                                                                                                                                                                                                  |
     * | Multiple point parameters                                                  | Will return all properties enclosed within a polygon defined by the given point parameters. At least 3 point parameters must be passed to define a polygon. The parameter `filter[sectors]` can be used with this parameter to filter results.                                                                                                                                                                                                                                                         |
     * | Royal Mail post town and thoroughfare (_with optional dependent locality_) | Will return all properties that align with the provided Royal Mail address values. Moreover, it offers the option to include the Royal Mail dependent locality parameter for further filtering based on address criteria. For instance, in scenarios where numerous "Main Streets" exist within a single post-town region, the dependent locality parameter assists in filtering to the correct locale, such as a village name. ([see PAF locality](https://en.wikipedia.org/wiki/Post_town#Locality)) |
     *
     * </details>
     *
     * ## Pagination
     *
     * <details>
     * <summary>Click to view information on using pagination for this endpoint</summary>
     *
     *  > This endpoint is paginated. [View the accompanying documentation](https://docs.data.api.street.co.uk/doc/user-guide-pOEzjc8scS#h-pagination) for more information on using pagination.
     * </details>
     *
     * ### Filtering
     *
     * <details>
     * <summary>Click to view information on filtering results</summary>
     *
     * Other `filter[]` query parameters can be included in any combination to allow for filtering of the result set.
     *
     * When using a lat/lon + radius or a polygon search, you can use the parameter `filter[sectors]` which takes multiple values to filter properties to sectors.
     * </details>
     *
     * ## Multiple valued query parameters
     *
     * <details>
     * <summary>Click to view information on using query parameters that take multiple values</summary>
     *
     * > [View the accompanying documentation](https://docs.data.api.street.co.uk/doc/user-guide-pOEzjc8scS#h-using-multiple-query-parameters) for more information on using query parameters that take multiple values.
     *
     * </details>
     *
     * ## Sorting
     *
     * <details>
     * <summary>Click to view information on using sorting for this endpoint</summary>
     *
     * > [View the accompanying documentation](https://docs.data.api.street.co.uk/doc/user-guide-pOEzjc8scS#h-sorting) for more information on using sorting.
     *
     * </details>
     */
    async getPropertiesInAreaAreasPropertiesGet(security, request, options) {
        return (0, fp_js_1.unwrapAsync)((0, areasGetPropertiesInAreaAreasPropertiesGet_js_1.areasGetPropertiesInAreaAreasPropertiesGet)(this, security, request, options));
    }
    /**
     * Get Property Listings In Area
     *
     * @remarks
     * Get property listings for an area.
     *
     * ## Valid query parameters
     *
     * <details>
     * <summary>Click to view information on valid query parameters for this endpoint</summary>
     *
     * The following combinations of query parameters are valid, invalid combinations will result in a `400 Bad Request`
     * with details why they are not valid.
     *
     * | Combination                       | Description                                                                                                                                                 |
     * | :-------------------------------- | :---------------------------------------------------------------------------------------------------------------------------------------------------------- |
     * | Postcode only                     | Will return only the listings in the postcode.                                                                                                            |
     * | Outcode only                      | Will return only the listings in the outcode.                                                                                                             |
     * | Single point parameter and radius | Will return all listings within the radius of the lat/lon given.                                                                                          |
     * | Multiple point parameters         | Will return all listings enclosed within a polygon defined by the given point parameters. At least 3 point parameters must be passed to define a polygon. |
     *
     * </details>
     *
     * ## Pagination
     *
     * <details>
     * <summary>Click to view information on using pagination for this endpoint</summary>
     *
     *  > This endpoint is paginated. [View the accompanying documentation](https://docs.data.api.street.co.uk/doc/user-guide-pOEzjc8scS#h-pagination) for more information on using pagination.
     * </details>
     *
     * ## Multiple valued query parameters
     *
     * <details>
     * <summary>Click to view information on using query parameters that take multiple values</summary>
     *
     * > [View the accompanying documentation](https://docs.data.api.street.co.uk/doc/user-guide-pOEzjc8scS#h-using-multiple-query-parameters) for more information on using query parameters that take multiple values.
     *
     * </details>
     *
     * ## Sorting
     *
     * <details>
     * <summary>Click to view information on using sorting for this endpoint</summary>
     *
     * > [View the accompanying documentation](https://docs.data.api.street.co.uk/doc/user-guide-pOEzjc8scS#h-sorting) for more information on using sorting.
     *
     * </details>
     */
    async getPropertyListingsInAreaAreasPropertyListingsGet(security, request, options) {
        return (0, fp_js_1.unwrapAsync)((0, areasGetPropertyListingsInAreaAreasPropertyListingsGet_js_1.areasGetPropertyListingsInAreaAreasPropertyListingsGet)(this, security, request, options));
    }
    /**
     * Get Property Transactions In Area
     *
     * @remarks
     * Get nearby completed property sale transactions for a location or property.
     *
     * ## Valid query parameters
     *
     * <details>
     * <summary>Click to view information on valid query parameters for this endpoint</summary>
     *
     * The following combinations of query parameters are valid, invalid combinations will result in a `400 Bad Request`
     * with details why they are not valid.
     *
     * | Combination                                                                | Description                                                                                                                                                                                                                                                                                                            |
     * | :------------------------------------------------------------------------- | :--------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------- |
     * | Postcode only                                                              | Will return only the transactions in the postcode.                                                                                                                                                                                                                                                                     |
     * | Outcode only                                                               | Will return only the transactions in the outcode.                                                                                                                                                                                                                                                                      |
     * | Single Street Group Property ID and radius                                 | Will return all transactions within the radius of the `street_group_property_id` given.                                                                                                                                                                                                                                |
     * | Single point parameter and radius                                          | Will return all transactions within the radius of the lat/lon given.                                                                                                                                                                                                                                                   |
     * | Multiple point parameters                                                  | Will return all transactions enclosed within a polygon defined by the given point parameters. At least 3 point parameters must be passed to define a polygon.                                                                                                                                                          |
     * | Royal Mail post town and thoroughfare (_with optional dependent locality_) | Will return all transactions that align with the provided Royal Mail address values. Moreover, it offers the option to include the Royal Mail dependent locality parameter for further filtering based on address criteria. For instance, in scenarios where numerous "Main Streets" exist within a single post-town region, the dependent locality parameter assists in filtering to the correct locale, such as a village name. ([see PAF locality](https://en.wikipedia.org/wiki/Post_town#Locality)) |
     *
     * </details>
     *
     * ## Pagination
     *
     * <details>
     * <summary>Click to view information on using pagination for this endpoint</summary>
     *
     *  > This endpoint is paginated. [View the accompanying documentation](https://docs.data.api.street.co.uk/doc/user-guide-pOEzjc8scS#h-pagination) for more information on using pagination.
     * </details>
     *
     * ### Filtering
     *
     * <details>
     * <summary>Click to view information on filtering results</summary>
     *
     * Other `filter[]` query parameters can be included in any combination to allow for filtering of the result set.
     *
     * Transactions can be filtered by date. You can pass both a start date and an end date, or any combination of the two,
     * in the from `YYYY-MM`. The start date must be less than or equal to the end date.
     * </details>
     *
     * ## Sorting
     *
     * <details>
     * <summary>Click to view information on using sorting for this endpoint</summary>
     *
     * > [View the accompanying documentation](https://docs.data.api.street.co.uk/doc/user-guide-pOEzjc8scS#h-sorting) for more information on using sorting.
     *
     * </details>
     */
    async getPropertyTransactionsInAreaAreasPropertyTransactionsGet(security, request, options) {
        return (0, fp_js_1.unwrapAsync)((0, areasGetPropertyTransactionsInAreaAreasPropertyTransactionsGet_js_1.areasGetPropertyTransactionsInAreaAreasPropertyTransactionsGet)(this, security, request, options));
    }
}
exports.Areas = Areas;
//# sourceMappingURL=areas.js.map